export enum CalendarViewTab {
  Week = 7,
  TodayPlus = 5,
  Day = 1,
  Month = 31
}
